module.exports = __webpack_public_path__ + "static/assets/140f6558329d052068724b61382cc22b.png";